import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import About from "./components/About";
import Coverage from "./components/Coverage";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { translations } from "./translations";
import React, { useState } from "react";


import "./styles/main.css";

function App() {
   const [lang, setLang] = useState("pl");

  const t = translations[lang];
  return (
    <div>
      <Navbar setLang={setLang} lang={lang} t={t} />
      <Hero t={t}/>
      <Services t={t}/>
      <About t={t} lang={lang}/>
      <Coverage t={t}/>
      <Contact t={t}/>
      <Footer t={t} lang={lang}/>
    </div>
  );
}

export default App;
